import React, { useState } from 'react';
import { Box } from '@radix-ui/themes';

interface AccordionProps {
  title: string;
  children: React.ReactNode;
}

const Accordion: React.FC<AccordionProps> = ({ title, children }) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleAccordion = () => {
        setIsOpen(!isOpen);
    };

    return (
        <><Box mb="1" mt="1">
            <div className="accordion-header" onClick={toggleAccordion}>
                <h3>{title}</h3>
                <span className={(isOpen && "open") + " material-symbols-rounded"}>{isOpen ? 'expand_less' : 'expand_more'}</span>
            </div>
            {isOpen && <div className="accordion-content">{children}</div>}
        </Box>
        <style jsx>
            {`
                .accordion-header {
                    display: flex;
                    gap: 1rem;
                    align-items: center;
                    cursor: pointer;
                    padding: 0.5rem 0.5rem;
                    margin-left: -0.5rem;
                    border-radius: calc(var(--border-radius)*2);
                    justify-content: space-between;
                }
                .accordion-header:hover {
                    background: var(--code-background);
                }
                .accordion-header:hover .material-symbols-rounded {
                    box-shadow: 0px 2px 0px 1px var(--code-border);
                    border-top: 1px solid var(--code-border);
                }
                .accordion {
                    border: 1px solid var(--code-border);
                    border-radius: var(--border-radius);
                    display: flex;
                    align-content: center;
                    flex-direction: column;
                }
                .material-symbols-rounded {
                    border-radius: var(--border-radius);
                    padding: 3px;
                    border-top: 1px solid transparent;
                }
                .open {
                    background: var(--code-border);
                }
                .material-symbols-rounded:hover {
                    background: var(--code-border);
                }
                .accordion-content {
                    margin-top: var(--default-vertical-spacing);
                    background: var(--code-background);
                    margin: 0px;
                    margin-bottom: 0px;
                    margin-top: 0px;
                    margin-left: -0.5rem;
                    padding: 0.5rem 0.5rem;
                    border-radius: calc(var(--border-radius)*2);
                }
                h3 {
                    margin: 0;
                    font-size: var(--font-size-4);
                }
            `}
        </style>
        </>
    );
};

export default Accordion;
